/**
 * Wires up snippets/b2b-access-popup.liquid - the "hospitality professionals
 * only" popup shown on a B2B-only product/collection page instead of the old
 * silent redirect. Closing it (X button, clicking outside the box, or Escape)
 * sends the visitor home, same as the redirect used to, just after explaining
 * why first.
 *
 * A plain external file rather than inline JS in the snippet: that markup
 * renders inside the Vue-templated #app root, and Vue's runtime compiler
 * drops <script> tags from in-DOM templates (same reason sl-signup-form.js
 * lives here instead of inline).
 */
(function () {
  function wire(overlay) {
    if (overlay.dataset.b2bGuardWired) return;
    overlay.dataset.b2bGuardWired = '1';

    var homeUrl = overlay.dataset.homeUrl || '/';
    var closeBtn = overlay.querySelector('[data-b2b-guard-close]');

    document.documentElement.style.overflow = 'hidden';

    function goHome() {
      window.location.href = homeUrl;
    }

    if (closeBtn) closeBtn.addEventListener('click', goHome);

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) goHome();
    });

    document.addEventListener('keydown', function onKeydown(event) {
      if (event.key !== 'Escape') return;
      document.removeEventListener('keydown', onKeydown);
      goHome();
    });
  }

  function init() {
    var overlay = document.getElementById('b2b-guard-popup-overlay');
    if (overlay) wire(overlay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // The section can render after this script runs (Vue hydration, or the
  // theme editor re-rendering sections), so keep checking for a little while.
  document.addEventListener('shopify:section:load', init);
  setTimeout(init, 1500);
  setTimeout(init, 4000);
})();
